import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-input-display',
  standalone: true,
  // If you need InputLabelComponent or InputValueComponent, import them in the imports array:
  imports: [CommonModule],
  templateUrl: './input-display.component.html',
  styleUrls: ['./input-display.component.scss'],
})
export class InputDisplayComponent {
  @Input() label?: string;
  @Input() value?: string;


  @Input() valueComponent?: string | null;
  @Input() includeMargin = false;
}
